import React from 'react'

const CustomLoader = (props) => {
  return (
    <div className="backdropD">
            <div className="custom_loader">
            <div className="lds-ripple"><div></div><div></div></div>
            </div>
        </div>
  )
}

export default CustomLoader